var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"variant":"info"}},[_vm._v("Pending Pay expected: "+_vm._s(_vm.pendingPayDate))]),_c('LineitemsPending',{attrs:{"pendingLineitems":_vm.pendingLineitems,"pendingPayDate":_vm.pendingPayDate,"pendingTotal":_vm.pendingTotal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }